<div class="header">
  <div class="container">
    <!-- Top Navbar -->
    <div class="navbar py-4 d-flex justify-content-between align-items-center">
      <div class="d-flex gap-2 align-items-center">
        <figure class="w-125px w-lg-150px rounded-4 d-flex justify-content-center align-items-center mb-0">
          <a href="javascript:void(0)" (click)="navigateHome()"><img class="w-100" src="../../assets/img/mainlogo.jpg"
              alt="Logo"></a>
        </figure>
      </div>

      <!-- Navbar Menu Items desktop-->
      <nav class="main_menu d-flex gap-4 align-items-center">
        <ng-container *ngTemplateOutlet="menu"></ng-container>
      </nav>
      
      <!-- Mobile right actions -->
      <div class="mobile_menu align-items-center gap-3">
        <!-- Notification -->
        <app-notification-panel *ngIf="isLoggedIn">
        </app-notification-panel>
      
        <!-- Hamburger -->
        <span class="d-inline-block cursor-pointer" (click)="menusidebarVisible = true">
          <i class="fa fa-bars fs-2x"></i>
        </span>
      
      </div>
    </div>
  </div>
  <p-progressBar class="top_progress custom-navbar-progress" mode="indeterminate" *ngIf="isLoader"
    [style]="{ height: '3px' }">
  </p-progressBar>
</div>

<!-- Mobile menu sidebar -->
<p-sidebar class="m_sidebarMenu" [(visible)]="menusidebarVisible" position="right">
  <ng-container *ngTemplateOutlet="menu"></ng-container>
</p-sidebar>

<!-- Navbar Menu Items -->
<ng-template #menu>
  <ul class="navbar-menu d-flex list-unstyled mb-0 gap-2 ">
    <li *ngFor="let menuItem of navbarMenu" class="nav-item">
      <ng-container *ngIf="menuItem.label === 'LANGUAGE_LABEL'; else regularItem">
        <p-dropdown class="country_select" [options]="languages" [(ngModel)]="selectedLanguage"
          [placeholder]="'SELECT_LANGUAGE' | translate" (onChange)="changeLanguage($event.value)">
          <ng-template let-language pTemplate="selectedItem">
            {{ language.label | translate }}
          </ng-template>
          <ng-template let-language pTemplate="item">
            {{ language.label | translate }}
          </ng-template>
        </p-dropdown>
      </ng-container>
      <ng-template #regularItem>
        <ng-container *ngIf="menuItem.route">
          <!-- Internal link (Angular routing) -->
          <a class="nav-link btn btn-flex h-40px px-2" *ngIf="!isExternalLink(menuItem.route)"
            [routerLink]="menuItem.route">
            {{ menuItem.label | translate }}
          </a>

          <!-- External link (Opens in new tab) -->
          <a class="nav-link btn btn-flex h-40px px-2" *ngIf="isExternalLink(menuItem.route)" [href]="menuItem.route"
            target="_blank" rel="noopener noreferrer">
            {{ menuItem.label | translate }}
          </a>
        </ng-container>
      </ng-template>
    </li>
      <!-- Notification Bell - Add this before login/avatar -->
    <li class="nav-item  d-md-block" *ngIf="isLoggedIn">
      <app-notification-panel></app-notification-panel>
    </li>
    <li class="login_btn cursor-pointer" *ngIf="!isLoggedIn" (click)="signInDialog()">
      <a class="oval_btn cursor-pointer btn btn-primary btn-flex h-40px">{{ 'LOGIN' | translate }}</a>
    </li>
    <!-- Avatar: Shown when the user is logged in -->
    <li class="avatar-btn cursor-pointer" *ngIf="isLoggedIn && !isProfileRoute()">
      <!-- <div class="card flex justify-content-center gap-2"></div> -->
      <div class="position-relative">
        <div class="loggeddUser d-flex gap-1 align-items-center" (click)="menu.toggle($event)">
          <!-- (click)="toggleMenu()" -->
          <p-avatar class="h-35px" [image]="(userImage$ | async) || '../../assets/img/user.jpg'" shape="circle"
            class="cursor-default"></p-avatar>
          <span class="text-capitalize fs-5">{{ (userInfo$ | async)?.firstName }}</span>
          <div class="m-0 d-flex flex-column h-100">
            <p-menu appendTo="body" #menu [model]="translatedItems1" [popup]="true"></p-menu>

            <!-- <p-button  (onClick)="menu.toggle($event)" appendTo="body" icon="pi pi-angle-down"/> -->
            <a class="d-flex"><i class="pi pi-angle-down text-2xl text-dark"></i></a>
          </div>
        </div>
      </div>


    </li>
  </ul>

  <!-- Sign in option selection modal -->
  <p-dialog header="{{ 'LOGIN_TYPE' | translate }}" [modal]="true" [(visible)]="signInModal"
    [style]="{ width: '25rem' }">
    <div class="d-flex flex-column mb-5">
      <a class="d-flex fs-3 cursor-pointer btn btn-primary-light btn-flex py-1 px-3 mb-0" (click)="individualLogin()">{{
        'LOGIN_AS_INDIVIDUAL' | translate }}</a>
      <span class="text-gray-500 fs-7"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> {{
        'INDIVIDUAL_DESCRIPTION' | translate }}</span>
    </div>
    <div class="d-flex flex-column mb-5">
      <a class="d-flex fs-3 cursor-pointer btn btn-primary-light btn-flex py-1 px-3 mb-0" (click)="organisationLogin()">
        {{ 'LOGIN_AS_ORGANIZATION' | translate }}</a>
      <span class="text-gray-500 fs-7"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> {{
        'ORGANIZATION_DESCRIPTION' | translate }}</span>
    </div>

    <!-- <ng-template pTemplate="footer">
    <div class="d-flex justify-content-end gap-2">
        <p-button label="Cancel" severity="secondary" (onClick)="signInModal = false" />
        <p-button label="Save" severity="primary" (onClick)="signInModal = false" />
    </div>
  </ng-template> -->
  </p-dialog>
